import axios from 'axios';

/**
 * @typedef {import('../../components/common/match/stream-manifest.model.js').default} StreamManifestModel
 */

/**
 * Get stream url for IMGArena stream provider
 * @param {StreamManifestModel} manifest - manifest model
 * @param {string} streamId - stream id
 */
export function getIMGArenaStream(manifest, streamId) {
	const params = {
		operatorId: APP_SETTINGS.lco.imgArenaOperatorId,
		timestamp: manifest.timestamp,
		auth: manifest.streamUrl,
	};
	const config = {
		method: 'get',
		url: `https://api.livestreaming.imgarena.com/api/v2/streaming/events/${streamId}/stream`,
		headers: {},
		params,
	};
	return axios(config).then(resp => ({
		errorCode: resp.data.statusCode === 200 ? 0 : resp.data.statusCode,
		src: resp.data.hlsUrl,
		type: 'application/x-mpegURL',
	}));
}

/**
 * Get stream url for Betradar stream provider
 * @param {StreamManifestModel} manifest
 */
export function getBetradarStream(manifest) {
	return {
		errorCode: manifest.errorCode,
		errorMsg: manifest.errorMsg,
		src: manifest.streamUrl,
		type: manifest.streamType === 1 ? 'application/dash+xml' : 'application/x-mpegURL',
	};
}

/**
 * Get twitch.tv embeded url
 * @param {string} streamId - stream id
 */
function getTwitchUrl(streamId) {
	const hostName = window.location.hostname;
	const channelName = streamId.substring(streamId.lastIndexOf('/') + 1);
	const twitchPlayerURL = `https://player.twitch.tv/?channel=${channelName}&parent=${hostName}&autoplay=true`;
	return twitchPlayerURL;
}

/**
 * Get youtube embeded url
 * @param {string} streamId - stream id
 */
function getYoutubeUrl(streamId) {
	const eqIndex = streamId.indexOf('=');
	const channelName = streamId.substring(
		eqIndex + 1,
		eqIndex + 12,
	);
	const youtubePlayerURL = `https://www.youtube.com/embed/${channelName}?autoplay=1`;
	return youtubePlayerURL;
}

/**
 * Get huya embeded url
 * @param {string} streamId - stream id
 */
function getHuyaUrl(streamId) {
	const channelName = streamId.substring(streamId.lastIndexOf('/') + 1);
	const huyaPlayerUrl = `https://liveshare.huya.com/iframe/${channelName}`;
	return huyaPlayerUrl;
}

/**
 * Get vpplayer embeded url
 * @param {string} streamId - stream id
 */
function getVPPlayerUrl(streamId) {
	const channelName = streamId.substring((streamId.lastIndexOf('/', (streamId.lastIndexOf('/') - 1)) + 1));
	const vpPlayerUrl = `https://host.vpplayer.tech/player/${channelName}`;
	return vpPlayerUrl;
}

/**
 * Get esports stream embeded url
 * @param {string} streamId - stream id
 */
export function getOddinStreamUrl(streamId) {
	switch (true) {
		case streamId.includes('twitch'):
			return getTwitchUrl(streamId);
		case streamId.includes('youtube'):
			return getYoutubeUrl(streamId);
		case streamId.includes('huya'):
			return getHuyaUrl(streamId);
		case streamId.includes('vpplayer'):
			return getVPPlayerUrl(streamId);
	}
	return '';
}

/**
 * Extract deep nested statspeform stream url
 * @param {{launchInfo?: {streamLauncher?: {launcherURL:string}[]}}} data
 */
function getStatsPeformStreamUrl(data) {
	return (data.launchInfo
		&& data.launchInfo.streamLauncher
		&& data.launchInfo.streamLauncher[0]
		&& data.launchInfo.streamLauncher[0].launcherURL) || '';
}

/**
 * Get stream url for Statsperform stream provider
 * @param {StreamManifestModel} manifest
 * @param {string} streamId - stream id
 */
export function getStatsPeformStream(manifest, streamId) {
	const outlet = APP_SETTINGS.lco.statsPerformOutlet;
	const params = {
		_fmt: "json",
		_fld: "sTok,sl,lTyp",
	};
	const config = {
		method: 'get',
		url: `https://wab.performfeeds.com/livestreamlaunch/${outlet}/${streamId}`,
		headers: {
			Authorization: 'Bearer ' + manifest.streamUrl,
		},
		params,
	};
	return axios(config).then(resp => ({
		errorCode: resp.data.errorCode || 0,
		src: getStatsPeformStreamUrl(resp.data),
		type: 'application/x-mpegURL',
	}));
}

/**
 * Get stream url for SIS stream provider
 * @param {string} streamId - stream id
 * @param {StreamManifestModel} manifest
 */
export function getSISStream(streamId, manifest) {
	const outlet = APP_SETTINGS.lco.sisCustomerHash;
	const name = APP_SETTINGS.player.id;
	const config = {
		method: 'get',
		url: `https://streamingapi.sis.tv/StreamingService/api/v2/stream?customer=${outlet}&streamId=${streamId}&username=${name}&token=${manifest.streamUrl}`,
	};
	return axios(config).then((resp) => ({
		errorCode: resp.data.error || 0,
		src: resp.data.hlsUrl,
		type: "application/x-mpegURL",
	}));
}
